module.exports = __webpack_public_path__ + "static/media/buyer_protection.e9161928.jpeg";